import React, { useEffect, useState } from "react";
import PaymentService from "../../Services/PaymentService";
import shippingStore from "../../stores/ShippingStore";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyOrderService from "../../Services/MyOrderService";
declare global {
  interface Window {
    __intellipayWidgetLoaded?: boolean;
  }
}
declare global {
  interface Window {
    intellipay?: any;
  }
}
export default function PayCard(props: any) {
  const navigate = useNavigate();

 

  const postPaymentSuccess = async (response: any) => {
    const shippingData = shippingStore.getShippingDetails();
    const shippingObject = {
      specialInstructions: shippingData.specialInstructions || "",
      shippingDetails: {
        firstName: shippingData.firstName,
        lastName: shippingData.lastName,
        phoneNo: shippingData.phoneNo,
        shippingAddress: shippingData.shippingAddress,
        country: shippingData.country,
        state: shippingData.state,
        city: shippingData.city,
        zipCode: shippingData.zipCode,
        shippingMethod: shippingData.shippingMethod,
      },
    };
    try {
      const orderObj = await MyOrderService.CreateOrder(shippingObject);
      console.log(orderObj);
      if (orderObj) {
        const status = response.response === "A" ? "approved" : "declined";
        const paymentType =
          response.paymenttype === "C" ? "returned for credit card transaction" : "returned for ACH transaction";
        const postPaymentPayload = {
          orderID: orderObj.orderId,
          amount: response.total,
          paymentType: paymentType,
          transactionId: response.status,
          paymentStatus: status,
        };
        const result = await PaymentService.PostPayment(postPaymentPayload);
        console.log(result?.data);
        if (result?.status === 200) {
          
          toast.success("Order created successfully", { position: "top-center" });
          setTimeout(() => {
            navigate("/paymentsuccessmessage", { 
              state: { 
                amount: result?.data.amount, 
                transactionId: result?.data.transactionId,
                paymentMethod:result?.data.paymentMethod
              } 
            });
          }, 1000);
          shippingStore.clearShippingDetails();
        } else {
          toast.error("Failed to generate your payment", { position: "top-center" });
        }
      } else {
        toast.error("Failed to create order", { position: "top-center" });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!window.__intellipayWidgetLoaded) {
      getIntellipayWidget()
        .then(() => {
          window.__intellipayWidgetLoaded = true;
        })
        .catch((error) => console.error("Widget load failed", error));
    } else {
      if (window.intellipay) {
        window.intellipay.initialize();
        window.intellipay.runOnApproval(postPaymentSuccess);
        window.intellipay.runOnNonApproval((res: any) => {
          console.error("Transaction not approved!", res);
        });
      }
    }
  }, []);
  

  const getIntellipayWidget = async () => {
    const response = await PaymentService.GetIntellipayWidget();
    if (response.success) {
      const range = document.createRange();
      document.documentElement.appendChild(
        range.createContextualFragment(response.data)
      );
      if (window.intellipay) {
        window.intellipay.initialize();
        window.intellipay.runOnApproval(postPaymentSuccess);
        window.intellipay.runOnNonApproval((res: any) =>
          console.log("transactions was not approved!", res)
        );
      }
    }
  };
  

  return (
    <div>
      
      <input className="ipayfield" data-ipayname="account" type="hidden" value={props.userId} />
      <input className="ipayfield" data-ipayname="email" type="hidden" value={props.userEmail} />
      <input className="ipayfield" data-ipayname="amount" type="hidden" value={props.paymentAmount} />
    </div>
  );
}
